import React, { createContext, useContext, useEffect, useState, useCallback } from "react";
import { fetchTranslations } from "../lib/api";

const LanguageContext = createContext(null);

export const SUPPORTED_LANGS = ["en", "te", "hi", "ta", "kn", "ml"];

const FALLBACK = {
  en: {
    navHome: "Home", navPanchangam: "Panchangam", langBtn: "Languages ▼",
    goodMorning: "Good Morning", goodAfternoon: "Good Afternoon",
    goodEvening: "Good Evening", goodNight: "Good Night",
    subHeading: "Today's Yagnika Panchangam",
    lblSamvatsaram: "Samvatsaram:", lblAyanam: "Ayanam:", lblRithuvu: "Rithuvu:",
    lblMasam: "Masam:", lblPaksham: "Paksham:", lblThidhi: "Thidhi:", lblNakshatram: "Nakshatram:",
    btnFullPanchangam: "Get Panchangam", kalaChakram: "Kala Chakram",
    sunrise: "Sunrise", sunset: "Sunset", moonrise: "Moonrise", moonset: "Moonset",
    suryamana: "Suryamana", amanta: "Chandramana Amanta", purnimanta: "Chandramana Purnimanta",
    lblMasamSuryamana: "Saura Masam", lblMasamAmanta: "Amanta Masam", lblMasamPurnimanta: "Purnimanta Masam",
    modalTimingsKalas: "Timings & Kalas", modalPanchangamDetails: "Panchangam Details",
    lblYogam: "Yogam", lblKaranam: "Karanam",
    muhurtamTitle: "Check Muhurtam", muhurtamSub: "Auspicious timing finder",
    muhurtamNakshatra: "Your Nakshatra", muhurtamRasi: "Your Rasi", muhurtamSystem: "Calendar System",
    muhurtamChandramana: "Chandramana", muhurtamSouramana: "Souramana", muhurtamBest: "Best (Both)",
    muhurtamStartDate: "From", muhurtamEndDate: "To", muhurtamCheck: "Find Good Muhurtams",
    muhurtamChecking: "Checking...", muhurtamNoResults: "No valid Muhurtams found in this range. Try extending it.",
    muhurtamExcluded: "Excluded Timings", muhurtamRahuKalam: "Rahu Kalam", muhurtamDurmuhurtam: "Durmuhurtam",
    muhurtamVarjyam: "Varjyam", muhurtamSafeWindows: "Safe Windows", muhurtamLagna: "Lagna",
    muhurtamLatitude: "Latitude", muhurtamLongitude: "Longitude", muhurtamTimezone: "Timezone (UTC offset, hrs)",
    muhurtamUseLocation: "📍 Use my location", muhurtamLocating: "Locating...",
    muhurtamLocationError: "Could not get your location. Please enter latitude/longitude manually.",
    muhurtamDisclaimerTitle: "What this checker covers",
    muhurtamSuitableFor: "✅ Suitable for (general auspicious events)",
    muhurtamNotSuitableFor: "⚠️ Not suitable for (major life events)",
    muhurtamDisclaimerNote: "This checker verifies Tara Balam, Chandra Balam, Tithi/Vara rules and Panchaka Rahitam, but does not yet check real-time planetary (Graha) positions in specific houses. Please consult a qualified priest or astrologer before finalizing dates for the life events above.",
    muhurtamGotIt: "Got it",
    muhurtamInlineNote: "⚠️ For general events only (job, vehicle, travel, property, etc.) — not for marriage, housewarming, upanayanam or naming ceremonies. Tap ⓘ for details.",
    extGraha: "Graha Positions", extLagna: "Lagna (Ascendant)", extChoghadiya: "Choghadiya",
    extHora: "Hora", extGowri: "Gowri Panchangam", extNakshatraInfo: "Nakshatra Details",
    extDishaShoola: "Disha Shoola (avoid travel towards)", extLord: "Lord", extDeity: "Deity",
    extGana: "Gana", extNadi: "Nadi", extRetrograde: "Retrograde", extCombust: "Combust",
    extRiseSet: "Rise / Set", extDay: "Day", extNight: "Night", extSpecialDay: "Today is:",
    extEkadashi: "Ekadashi", extPournami: "Pournami (Full Moon)", extAmavasya: "Amavasya (New Moon)",
    extBhadra: "Bhadra (Vishti Karana) is active",
    muhurtamCitySearch: "Search city / place name",
    locPincode: "PIN code (India)", locPincodePlaceholder: "6-digit PIN code",
    locPincodeNotFound: "PIN code not found", locPickMap: "📍 Pick on map",
    mapPickerTitle: "Pick Location on Map", mapPickerHint: "Tap anywhere on the map",
    mapPickerConfirm: "Confirm", mapPickerSearchPlaceholder: "Search city or PIN code",
    mapPickerSearchNoResults: "No matches — tap the map instead", mapPickerSearching: "Searching…",
    locSearching: "Searching…", locSearchNoResults: "No matches found",
    locNear: "Near", locCustom: "Custom coordinates",
    calSuryamanaHelp: "Solar calendar", calAmantaHelp: "Lunar — month ends at new moon",
    calPurnimantaHelp: "Lunar — month ends at full moon",
  },
  te: {
    navHome: "ముఖ్య పుట", navPanchangam: "పంచాంగం", langBtn: "భాషలు ▼",
    goodMorning: "శుభోదయం", goodAfternoon: "శుభ మధ్యాహ్నం",
    goodEvening: "శుభ సాయంత్రం", goodNight: "శుభ రాత్రి",
    subHeading: "నేటి యాజ్ఞిక పంచాంగం",
    lblSamvatsaram: "సంవత్సరం:", lblAyanam: "అయనం:", lblRithuvu: "ఋతువు:",
    lblMasam: "మాసం:", lblPaksham: "పక్షం:", lblThidhi: "తిథి:", lblNakshatram: "నక్షత్రం:",
    btnFullPanchangam: "సంపూర్ణ పంచాంగం", kalaChakram: "కాల చక్రం",
    sunrise: "సూర్యోదయం", sunset: "సూర్యాస్తమయం",
    moonrise: "చంద్రోదయం", moonset: "చంద్రాస్తమయం",
    suryamana: "సౌరమానం", amanta: "చాంద్రమానం (అమాంత)",
    purnimanta: "చాంద్రమానం (పూర్ణిమాంత)",
    lblMasamSuryamana: "సౌర మాసం", lblMasamAmanta: "అమాంత మాసం", lblMasamPurnimanta: "పూర్ణిమాంత మాసం",
    modalTimingsKalas: "సమయాలు", modalPanchangamDetails: "పంచాంగ వివరాలు",
    lblYogam: "యోగం", lblKaranam: "కరణం",
    muhurtamTitle: "మంచి ముహూర్తం", muhurtamSub: "శుభ ముహూర్త అన్వేషణ",
    muhurtamNakshatra: "మీ నక్షత్రం", muhurtamRasi: "మీ రాశి", muhurtamSystem: "పంచాంగ విధానం",
    muhurtamChandramana: "చాంద్రమానం", muhurtamSouramana: "సౌరమానం", muhurtamBest: "ఉత్తమం (రెండూ)",
    muhurtamStartDate: "నుండి", muhurtamEndDate: "వరకు", muhurtamCheck: "మంచి ముహూర్తాలు కనుగొనుడి",
    muhurtamChecking: "పరిశీలిస్తోంది...", muhurtamNoResults: "ఈ పరిధిలో మంచి ముహూర్తాలు కనబడలేదు. పరిధిని పెంచి ప్రత్నించండి.",
    muhurtamExcluded: "మినహాయించిన సమయాలు", muhurtamRahuKalam: "రాహుకాలం", muhurtamDurmuhurtam: "దుర్ముహూర్తం",
    muhurtamVarjyam: "వర్జ్యం", muhurtamSafeWindows: "శుభ సమయాలు", muhurtamLagna: "లగ్నం",
    muhurtamLatitude: "అక్షాంశం", muhurtamLongitude: "రేఖాంశం", muhurtamTimezone: "కాలమండలం (UTC ఆఫ్‌సెట్, గం.)",
    muhurtamUseLocation: "📍 నా లొకేషన్ వాడండి", muhurtamLocating: "గుర్తిస్తోంది...",
    muhurtamLocationError: "మీ లొకేషన్ పొందలేకపోయాం. దయచేసి అక్షాంశం/రేఖాంశం మానవీయంగా నమోదు చేయండి.",
    muhurtamDisclaimerTitle: "ఈ పరిశీలన దేనికి వర్తిస్తుంది",
    muhurtamSuitableFor: "✅ వీటికి అనుకూలం (సాధారణ శుభ కార్యాలు)",
    muhurtamNotSuitableFor: "⚠️ వీటికి అనుకూలం కాదు (ప్రధాన జీవిత ఘట్టాలు)",
    muhurtamDisclaimerNote: "ఈ పరిశీలన తార బలం, చంద్ర బలం, తిథి/వార నియమాలు మరియు పంచక రహితం చూస్తుంది, కానీ నిర్దిష్ట ఇళ్లలో గ్రహాల వాస్తవ స్థానాలను ఇంకా పరిశీలించదు. పైన పేర్కొన్న ప్రధాన జీవిత ఘట్టాలకు తేదీలను ఖరారు చేసే ముందు దయచేసి అర్హత గల పురోహితుడు లేదా జ్యోతిష్కుడిని సంప్రదించండి.",
    muhurtamGotIt: "అర్థమైంది",
    muhurtamInlineNote: "⚠️ సాధారణ కార్యాలకు మాత్రమే (ఉద్యోగం, వాహనం, ప్రయాణం, ఆస్తి మొదలైనవి) — వివాహం, గృహప్రవేశం, ఉపనయనం లేదా నామకరణానికి కాదు. వివరాల కోసం ⓘ నొక్కండి.",
    extGraha: "గ్రహ స్థానాలు", extLagna: "లగ్నం", extChoghadiya: "చోఘడియ",
    extHora: "హోర", extGowri: "గౌరీ పంచాంగం", extNakshatraInfo: "నక్షత్ర వివరాలు",
    extDishaShoola: "దిశా శూల (ఈ దిశలో ప్రయాణం మానుకోండి)", extLord: "అధిపతి", extDeity: "దేవత",
    extGana: "గణం", extNadi: "నాడి", extRetrograde: "వక్రి", extCombust: "అస్తంగత",
    extRiseSet: "ఉదయం / అస్తమయం", extDay: "పగలు", extNight: "రాత్రి", extSpecialDay: "ఈరోజు:",
    extEkadashi: "ఏకాదశి", extPournami: "పౌర్ణమి", extAmavasya: "అమావాస్య",
    extBhadra: "భద్ర (విష్టి కరణం) ఉంది",
    muhurtamCitySearch: "నగరం / ప్రదేశం వెతకండి",
    locPincode: "పిన్ కోడ్ (భారత్)", locPincodePlaceholder: "6 అంకెల పిన్ కోడ్",
    locPincodeNotFound: "పిన్ కోడ్ కనబడలేదు", locPickMap: "📍 మ్యాప్‌లో ఎంచుకోండి",
    mapPickerTitle: "మ్యాప్‌లో స్థానం ఎంచుకోండి", mapPickerHint: "మ్యాప్‌లో ఎక్కడైనా నొక్కండి",
    mapPickerConfirm: "నిర్ధారించండి", mapPickerSearchPlaceholder: "నగరం లేదా పిన్ కోడ్ వెతకండి",
    mapPickerSearchNoResults: "సరిపోలలేదు — మ్యాప్‌పై నొక్కండి", mapPickerSearching: "వెతుకుతోంది…",
    locSearching: "వెతుకుతోంది…", locSearchNoResults: "సరిపోలికలు కనబడలేదు",
    locNear: "సమీపంలో", locCustom: "మీరు నమోదు చేసిన స్థానం",
    calSuryamanaHelp: "సౌర పంచాంగం", calAmantaHelp: "చాంద్రమానం — అమావాస్యతో మాసం ముగుస్తుంది",
    calPurnimantaHelp: "చాంద్రమానం — పౌర్ణమితో మాసం ముగుస్తుంది",
  },
  hi: {
    navHome: "होम", navPanchangam: "पंचांग", langBtn: "भाषाएँ ▼",
    goodMorning: "शुभ प्रभात", goodAfternoon: "शुभ दोपहर",
    goodEvening: "शुभ संध्या", goodNight: "शुभ रात्रि",
    subHeading: "आज का यज्ञिक पंचांग",
    lblSamvatsaram: "संवत्सर:", lblAyanam: "अयन:", lblRithuvu: "ऋतु:",
    lblMasam: "मास:", lblPaksham: "पक्ष:", lblThidhi: "तिथि:", lblNakshatram: "नक्षत्र:",
    btnFullPanchangam: "संपूर्ण पंचांग देखें", kalaChakram: "काल चक्र",
    sunrise: "सूर्योदय", sunset: "सूर्यास्त", moonrise: "चंद्रोदय", moonset: "चंद्रास्त",
    suryamana: "सौरमान", amanta: "चांद्रमान (अमांत)", purnimanta: "चांद्रमान (पूर्णिमांत)",
    lblMasamSuryamana: "सौर मास", lblMasamAmanta: "अमांत मास", lblMasamPurnimanta: "पूर्णिमांत मास",
    modalTimingsKalas: "समय व कालाएं", modalPanchangamDetails: "पंचांग विवरण",
    lblYogam: "योग", lblKaranam: "करण",
    muhurtamTitle: "मुहूर्त जांचें", muhurtamSub: "शुभ मुहूर्त खोजक",
    muhurtamNakshatra: "आपका नक्षत्र", muhurtamRasi: "आपकी राशि", muhurtamSystem: "पंचांग प्रणाली",
    muhurtamChandramana: "चांद्रमान", muhurtamSouramana: "सौरमान", muhurtamBest: "सर्वश्रेष्ठ (दोनों)",
    muhurtamStartDate: "से", muhurtamEndDate: "तक", muhurtamCheck: "शुभ मुहूर्त खोजें",
    muhurtamChecking: "जांच हो रही है...", muhurtamNoResults: "इस अवधि में कोई शुभ मुहूर्त नहीं मिला। अवधि बढ़ाकर देखें।",
    muhurtamExcluded: "वर्जित समय", muhurtamRahuKalam: "राहुकाल", muhurtamDurmuhurtam: "दुर्मुहूर्त",
    muhurtamVarjyam: "वर्ज्यम्", muhurtamSafeWindows: "शुभ समय", muhurtamLagna: "लग्न",
    muhurtamLatitude: "अक्षांश", muhurtamLongitude: "देशांतर", muhurtamTimezone: "समय क्षेत्र (UTC ऑफ़सेट, घं.)",
    muhurtamUseLocation: "📍 मेरा स्थान उपयोग करें", muhurtamLocating: "स्थान ढूँढा जा रहा है...",
    muhurtamLocationError: "आपका स्थान प्राप्त नहीं हो सका। कृपया अक्षांश/देशांतर मैन्युअल रूप से दर्ज करें।",
    muhurtamDisclaimerTitle: "यह जांच किसके लिए है",
    muhurtamSuitableFor: "✅ इनके लिए उपयुक्त (सामान्य शुभ कार्य)",
    muhurtamNotSuitableFor: "⚠️ इनके लिए उपयुक्त नहीं (प्रमुख जीवन संस्कार)",
    muhurtamDisclaimerNote: "यह जांच तारा बल, चंद्र बल, तिथि/वार नियम और पंचक रहित की जांच करती है, लेकिन विशिष्ट भावों में ग्रहों की वास्तविक स्थिति की जांच अभी नहीं करती। ऊपर बताए गए जीवन संस्कारों के लिए तिथि तय करने से पहले कृपया किसी योग्य पुरोहित या ज्योतिषी से सलाह लें।",
    muhurtamGotIt: "समझ गया",
    muhurtamInlineNote: "⚠️ केवल सामान्य कार्यों के लिए (नौकरी, वाहन, यात्रा, संपत्ति आदि) — विवाह, गृहप्रवेश, उपनयन या नामकरण के लिए नहीं। विवरण हेतु ⓘ दबाएँ।",
    extGraha: "ग्रह स्थितियाँ", extLagna: "लग्न", extChoghadiya: "चौघड़िया",
    extHora: "होरा", extGowri: "गौरी पंचांग", extNakshatraInfo: "नक्षत्र विवरण",
    extDishaShoola: "दिशा शूल (इस दिशा में यात्रा टालें)", extLord: "स्वामी", extDeity: "देवता",
    extGana: "गण", extNadi: "नाड़ी", extRetrograde: "वक्री", extCombust: "अस्त",
    extRiseSet: "उदय / अस्त", extDay: "दिन", extNight: "रात", extSpecialDay: "आज है:",
    extEkadashi: "एकादशी", extPournami: "पूर्णिमा", extAmavasya: "अमावस्या",
    extBhadra: "भद्रा (विष्टि करण) है",
    muhurtamCitySearch: "शहर / स्थान खोजें",
    locPincode: "पिन कोड (भारत)", locPincodePlaceholder: "6 अंकों का पिन कोड",
    locPincodeNotFound: "पिन कोड नहीं मिला", locPickMap: "📍 मानचित्र पर चुनें",
    mapPickerTitle: "मानचित्र पर स्थान चुनें", mapPickerHint: "मानचित्र पर कहीं भी टैप करें",
    mapPickerConfirm: "पुष्टि करें", mapPickerSearchPlaceholder: "शहर या पिन कोड खोजें",
    mapPickerSearchNoResults: "कोई मेल नहीं — मानचित्र पर टैप करें", mapPickerSearching: "खोज रहे हैं…",
    locSearching: "खोज रहे हैं…", locSearchNoResults: "कोई मेल नहीं मिला",
    locNear: "समीप", locCustom: "आपके द्वारा दर्ज किया गया स्थान",
    calSuryamanaHelp: "सौर पंचांग", calAmantaHelp: "चांद्रमान — अमावस्या पर मास समाप्त",
    calPurnimantaHelp: "चांद्रमान — पूर्णिमा पर मास समाप्त",
  },
  ta: {
    navHome: "முகப்பு", navPanchangam: "பஞ்சாங்கம்", langBtn: "மொழிகள் ▼",
    goodMorning: "காலை வணக்கம்", goodAfternoon: "மதிய வணக்கம்",
    goodEvening: "மாலை வணக்கம்", goodNight: "இரவு வணக்கம்",
    subHeading: "இன்றைய யாக்ஞிக பஞ்சாங்கம்",
    lblSamvatsaram: "சம்வத்சரம்:", lblAyanam: "அயனம்:", lblRithuvu: "ருது:",
    lblMasam: "மாசம்:", lblPaksham: "பக்ஷம்:", lblThidhi: "திதி:", lblNakshatram: "நக்ஷத்திரம்:",
    btnFullPanchangam: "முழு பஞ்சாங்கம்", kalaChakram: "கால சக்ரம்",
    sunrise: "சூரிய உதயம்", sunset: "சூரிய அஸ்தமனம்", moonrise: "சந்திர உதயம்", moonset: "சந்திர அஸ்தமனம்",
    suryamana: "சௌரமானம்", amanta: "சாந்திரமானம் (அமாந்த)", purnimanta: "சாந்திரமானம் (பூர்ணிமாந்த)",
    lblMasamSuryamana: "சௌர மாசம்", lblMasamAmanta: "அமாந்த மாசம்", lblMasamPurnimanta: "பூர்ணிமாந்த மாசம்",
    modalTimingsKalas: "நேரங்கள் & காலங்கள்", modalPanchangamDetails: "பஞ்சாங்க விவரங்கள்",
    lblYogam: "யோகம்", lblKaranam: "கரணம்",
    muhurtamTitle: "முகூர்த்தம் சரிபார்க்க", muhurtamSub: "சுப முகூர்த்த கண்டுபிடிப்பான்",
    muhurtamNakshatra: "உங்கள் நக்ஷத்திரம்", muhurtamRasi: "உங்கள் ராசி", muhurtamSystem: "பஞ்சாங்க முறை",
    muhurtamChandramana: "சாந்திரமானம்", muhurtamSouramana: "சௌரமானம்", muhurtamBest: "சிறந்தது (இரண்டும்)",
    muhurtamStartDate: "இருந்து", muhurtamEndDate: "வரை", muhurtamCheck: "நல்ல முகூர்த்தங்களைக் கண்டறியவும்",
    muhurtamChecking: "சரிபார்க்கிறது...", muhurtamNoResults: "இந்த காலத்தில் நல்ல முகூர்த்தம் கிடைக்கவில்லை. காலத்தை நீட்டிக்கவும்.",
    muhurtamExcluded: "நீக்கப்பட்ட நேரங்கள்", muhurtamRahuKalam: "ராகு காலம்", muhurtamDurmuhurtam: "துர்முகூர்த்தம்",
    muhurtamVarjyam: "வர்ஜ்யம்", muhurtamSafeWindows: "பாதுகாப்பான நேரங்கள்", muhurtamLagna: "லக்னம்",
    muhurtamLatitude: "அட்சரேகை", muhurtamLongitude: "தீர்க்கரேகை", muhurtamTimezone: "நேர மண்டலம் (UTC ஆஃப்செட், மணி)",
    muhurtamUseLocation: "📍 எனது இருப்பிடத்தைப் பயன்படுத்து", muhurtamLocating: "இருப்பிடம் கண்டறியப்படுகிறது...",
    muhurtamLocationError: "உங்கள் இருப்பிடத்தைப் பெற முடியவில்லை. அட்சரேகை/தீர்க்கரேகையை கைமுறையாக உள்ளிடவும்.",
    muhurtamDisclaimerTitle: "இந்த சரிபார்ப்பு எதற்கானது",
    muhurtamSuitableFor: "✅ இவற்றுக்கு ஏற்றது (பொது சுப காரியங்கள்)",
    muhurtamNotSuitableFor: "⚠️ இவற்றுக்கு ஏற்றது அல்ல (முக்கிய வாழ்க்கை நிகழ்வுகள்)",
    muhurtamDisclaimerNote: "இந்த சரிபார்ப்பு தாரா பலம், சந்திர பலம், திதி/வார விதிகள் மற்றும் பஞ்சக ரஹிதம் ஆகியவற்றை சரிபார்க்கிறது, ஆனால் குறிப்பிட்ட பாவங்களில் கிரகங்களின் உண்மையான நிலையை இன்னும் சரிபார்க்கவில்லை. மேலே குறிப்பிடப்பட்ட வாழ்க்கை நிகழ்வுகளுக்கு தேதிகளை முடிவு செய்யும் முன் தகுதியான புரோகிதர் அல்லது ஜோதிடரை அணுகவும்.",
    muhurtamGotIt: "புரிந்தது",
    muhurtamInlineNote: "⚠️ பொது காரியங்களுக்கு மட்டும் (வேலை, வாகனம், பயணம், சொத்து போன்றவை) — திருமணம், கிரகப்ரவேசம், உபநயனம் அல்லது நாமகரணத்திற்கு அல்ல. விவரங்களுக்கு ⓘ ஐ அழுத்தவும்.",
    extGraha: "கிரக நிலைகள்", extLagna: "லக்னம்", extChoghadiya: "சோகடியா",
    extHora: "ஹோரை", extGowri: "கௌரி பஞ்சாங்கம்", extNakshatraInfo: "நக்ஷத்திர விவரங்கள்",
    extDishaShoola: "திசா சூலம் (இந்த திசையில் பயணம் தவிர்க்கவும்)", extLord: "அதிபதி", extDeity: "தேவதை",
    extGana: "கணம்", extNadi: "நாடி", extRetrograde: "வக்ரம்", extCombust: "அஸ்தமனம்",
    extRiseSet: "உதயம் / அஸ்தமனம்", extDay: "பகல்", extNight: "இரவு", extSpecialDay: "இன்று:",
    extEkadashi: "ஏகாதசி", extPournami: "பௌர்ணமி", extAmavasya: "அமாவாசை",
    extBhadra: "பத்ரை (விஷ்டி கரணம்) உள்ளது",
    muhurtamCitySearch: "நகரம் / இடம் தேடுங்கள்",
    locPincode: "பின் கோட் (இந்தியா)", locPincodePlaceholder: "6 இலக்க பின் கோட்",
    locPincodeNotFound: "பின் கோட் கிடைக்கவில்லை", locPickMap: "📍 வரைபடத்தில் தேர்ந்தெடுக்கவும்",
    mapPickerTitle: "வரைபடத்தில் இடத்தைத் தேர்ந்தெடுக்கவும்", mapPickerHint: "வரைபடத்தில் எங்கும் தட்டவும்",
    mapPickerConfirm: "உறுதிசெய்", mapPickerSearchPlaceholder: "நகரம் அல்லது பின் கோட் தேடவும்",
    mapPickerSearchNoResults: "பொருத்தமில்லை — வரைபடத்தில் தட்டவும்", mapPickerSearching: "தேடுகிறது…",
    locSearching: "தேடுகிறது…", locSearchNoResults: "பொருத்தங்கள் இல்லை",
    locNear: "அருகில்", locCustom: "நீங்கள் உள்ளிட்ட இடம்",
    calSuryamanaHelp: "சூரிய பஞ்சாங்கம்", calAmantaHelp: "சாந்திரமானம் — அமாவாசையில் மாதம் முடிவு",
    calPurnimantaHelp: "சாந்திரமானம் — பௌர்ணமியில் மாதம் முடிவு",
  },
  kn: {
    navHome: "ಮುಖಪುಟ", navPanchangam: "ಪಂಚಾಂಗ", langBtn: "ಭಾಷೆಗಳು ▼",
    goodMorning: "ಶುಭೋದಯ", goodAfternoon: "ಶುಭ ಮಧ್ಯಾಹ್ನ",
    goodEvening: "ಶುಭ ಸಂಜೆ", goodNight: "ಶುಭ ರಾತ್ರಿ",
    subHeading: "ಇಂದಿನ ಯಾಜ್ಞಿಕ ಪಂಚಾಂಗ",
    lblSamvatsaram: "ಸಂವತ್ಸರ:", lblAyanam: "ಅಯನ:", lblRithuvu: "ಋತು:",
    lblMasam: "ಮಾಸ:", lblPaksham: "ಪಕ್ಷ:", lblThidhi: "ತಿಥಿ:", lblNakshatram: "ನಕ್ಷತ್ರ:",
    btnFullPanchangam: "ಸಂಪೂರ್ಣ ಪಂಚಾಂಗ", kalaChakram: "ಕಾಲ ಚಕ್ರ",
    sunrise: "ಸೂರ್ಯೋದಯ", sunset: "ಸೂರ್ಯಾಸ್ತ", moonrise: "ಚಂದ್ರೋದಯ", moonset: "ಚಂದ್ರಾಸ್ತ",
    suryamana: "ಸೌರಮಾನ", amanta: "ಚಾಂದ್ರಮಾನ (ಅಮಾಂತ)", purnimanta: "ಚಾಂದ್ರಮಾನ (ಪೂರ್ಣಿಮಾಂತ)",
    lblMasamSuryamana: "ಸೌರ ಮಾಸ", lblMasamAmanta: "ಅಮಾಂತ ಮಾಸ", lblMasamPurnimanta: "ಪೂರ್ಣಿಮಾಂತ ಮಾಸ",
    modalTimingsKalas: "ಸಮಯಗಳು ಮತ್ತು ಕಾಲಗಳು", modalPanchangamDetails: "ಪಂಚಾಂಗ ವಿವರಗಳು",
    lblYogam: "ಯೋಗ", lblKaranam: "ಕರಣ",
    muhurtamTitle: "ಮುಹೂರ್ತ ಪರಿಶೀಲಿಸಿ", muhurtamSub: "ಶುಭ ಮುಹೂರ್ತ ಶೋಧಕ",
    muhurtamNakshatra: "ನಿಮ್ಮ ನಕ್ಷತ್ರ", muhurtamRasi: "ನಿಮ್ಮ ರಾಶಿ", muhurtamSystem: "ಪಂಚಾಂಗ ಪದ್ಧತಿ",
    muhurtamChandramana: "ಚಾಂದ್ರಮಾನ", muhurtamSouramana: "ಸೌರಮಾನ", muhurtamBest: "ಉತ್ತಮ (ಎರಡೂ)",
    muhurtamStartDate: "ಇಂದ", muhurtamEndDate: "ವರೆಗೆ", muhurtamCheck: "ಒಳ್ಳೆಯ ಮುಹೂರ್ತಗಳನ್ನು ಹುಡುಕಿ",
    muhurtamChecking: "ಪರಿಶೀಲಿಸಲಾಗುತ್ತಿದೆ...", muhurtamNoResults: "ಈ ಅವಧಿಯಲ್ಲಿ ಒಳ್ಳೆಯ ಮುಹೂರ್ತ ಸಿಗಲಿಲ್ಲ. ಅವಧಿಯನ್ನು ವಿಸ್ತರಿಸಿ ಪ್ರಯತ್ನಿಸಿ.",
    muhurtamExcluded: "ಹೊರಗಿಟ್ಟ ಸಮಯಗಳು", muhurtamRahuKalam: "ರಾಹುಕಾಲ", muhurtamDurmuhurtam: "ದುರ್ಮುಹೂರ್ತ",
    muhurtamVarjyam: "ವರ್ಜ್ಯ", muhurtamSafeWindows: "ಶುಭ ಸಮಯಗಳು", muhurtamLagna: "ಲಗ್ನ",
    muhurtamLatitude: "ಅಕ್ಷಾಂಶ", muhurtamLongitude: "ರೇಖಾಂಶ", muhurtamTimezone: "ಸಮಯ ವಲಯ (UTC ಆಫ್‌ಸೆಟ್, ಗಂ.)",
    muhurtamUseLocation: "📍 ನನ್ನ ಸ್ಥಳ ಬಳಸಿ", muhurtamLocating: "ಸ್ಥಳ ಪತ್ತೆ ಮಾಡಲಾಗುತ್ತಿದೆ...",
    muhurtamLocationError: "ನಿಮ್ಮ ಸ್ಥಳವನ್ನು ಪಡೆಯಲಾಗಲಿಲ್ಲ. ದಯವಿಟ್ಟು ಅಕ್ಷಾಂಶ/ರೇಖಾಂಶವನ್ನು ಹಸ್ತಚಾಲಿತವಾಗಿ ನಮೂದಿಸಿ.",
    muhurtamDisclaimerTitle: "ಈ ಪರಿಶೀಲನೆ ಯಾವುದಕ್ಕೆ ಅನ್ವಯಿಸುತ್ತದೆ",
    muhurtamSuitableFor: "✅ ಇವುಗಳಿಗೆ ಸೂಕ್ತ (ಸಾಮಾನ್ಯ ಶುಭ ಕಾರ್ಯಗಳು)",
    muhurtamNotSuitableFor: "⚠️ ಇವುಗಳಿಗೆ ಸೂಕ್ತವಲ್ಲ (ಪ್ರಮುಖ ಜೀವನ ಘಟ್ಟಗಳು)",
    muhurtamDisclaimerNote: "ಈ ಪರಿಶೀಲನೆ ತಾರಾ ಬಲ, ಚಂದ್ರ ಬಲ, ತಿಥಿ/ವಾರ ನಿಯಮಗಳು ಮತ್ತು ಪಂಚಕ ರಹಿತವನ್ನು ಪರಿಶೀಲಿಸುತ್ತದೆ, ಆದರೆ ನಿರ್ದಿಷ್ಟ ಭಾವಗಳಲ್ಲಿ ಗ್ರಹಗಳ ನೈಜ ಸ್ಥಾನಗಳನ್ನು ಇನ್ನೂ ಪರಿಶೀಲಿಸುವುದಿಲ್ಲ. ಮೇಲೆ ತಿಳಿಸಿದ ಜೀವನ ಘಟ್ಟಗಳಿಗೆ ದಿನಾಂಕಗಳನ್ನು ಅಂತಿಮಗೊಳಿಸುವ ಮೊದಲು ದಯವಿಟ್ಟು ಅರ್ಹ ಪುರೋಹಿತರು ಅಥವಾ ಜ್ಯೋತಿಷಿಗಳನ್ನು ಸಂಪರ್ಕಿಸಿ.",
    muhurtamGotIt: "ಅರ್ಥವಾಯಿತು",
    muhurtamInlineNote: "⚠️ ಸಾಮಾನ್ಯ ಕಾರ್ಯಗಳಿಗೆ ಮಾತ್ರ (ಉದ್ಯೋಗ, ವಾಹನ, ಪ್ರಯಾಣ, ಆಸ್ತಿ ಇತ್ಯಾದಿ) — ಮದುವೆ, ಗೃಹಪ್ರವೇಶ, ಉಪನಯನ ಅಥವಾ ನಾಮಕರಣಕ್ಕೆ ಅಲ್ಲ. ವಿವರಗಳಿಗೆ ⓘ ಒತ್ತಿ.",
    extGraha: "ಗ್ರಹ ಸ್ಥಾನಗಳು", extLagna: "ಲಗ್ನ", extChoghadiya: "ಚೌಘಡಿಯಾ",
    extHora: "ಹೋರಾ", extGowri: "ಗೌರಿ ಪಂಚಾಂಗ", extNakshatraInfo: "ನಕ್ಷತ್ರ ವಿವರಗಳು",
    extDishaShoola: "ದಿಶಾ ಶೂಲ (ಈ ದಿಕ್ಕಿನಲ್ಲಿ ಪ್ರಯಾಣ ತಪ್ಪಿಸಿ)", extLord: "ಒಡೆಯ", extDeity: "ದೇವತೆ",
    extGana: "ಗಣ", extNadi: "ನಾಡಿ", extRetrograde: "ವಕ್ರಿ", extCombust: "ಅಸ್ತ",
    extRiseSet: "ಉದಯ / ಅಸ್ತ", extDay: "ಹಗಲು", extNight: "ರಾತ್ರಿ", extSpecialDay: "ಇಂದು:",
    extEkadashi: "ಏಕಾದಶಿ", extPournami: "ಹುಣ್ಣಿಮೆ", extAmavasya: "ಅಮಾವಾಸ್ಯೆ",
    extBhadra: "ಭದ್ರಾ (ವಿಷ್ಟಿ ಕರಣ) ಇದೆ",
    muhurtamCitySearch: "ನಗರ / ಸ್ಥಳ ಹುಡುಕಿ",
    locPincode: "ಪಿನ್ ಕೋಡ್ (ಭಾರತ)", locPincodePlaceholder: "6 ಅಂಕಿಯ ಪಿನ್ ಕೋಡ್",
    locPincodeNotFound: "ಪಿನ್ ಕೋಡ್ ಸಿಗಲಿಲ್ಲ", locPickMap: "📍 ನಕ್ಷೆಯಲ್ಲಿ ಆಯ್ಕೆಮಾಡಿ",
    mapPickerTitle: "ನಕ್ಷೆಯಲ್ಲಿ ಸ್ಥಳ ಆಯ್ಕೆಮಾಡಿ", mapPickerHint: "ನಕ್ಷೆಯಲ್ಲಿ ಎಲ್ಲಿಯಾದರೂ ಟ್ಯಾಪ್ ಮಾಡಿ",
    mapPickerConfirm: "ದೃಢೀಕರಿಸಿ", mapPickerSearchPlaceholder: "ನಗರ ಅಥವಾ ಪಿನ್ ಕೋಡ್ ಹುಡುಕಿ",
    mapPickerSearchNoResults: "ಹೊಂದಾಣಿಕೆಗಳಿಲ್ಲ — ನಕ್ಷೆಯ ಮೇಲೆ ಟ್ಯಾಪ್ ಮಾಡಿ", mapPickerSearching: "ಹುಡುಕುತ್ತಿದೆ…",
    locSearching: "ಹುಡುಕುತ್ತಿದೆ…", locSearchNoResults: "ಹೊಂದಾಣಿಕೆಗಳು ಕಂಡುಬಂದಿಲ್ಲ",
    locNear: "ಸಮೀಪ", locCustom: "ನೀವು ನಮೂದಿಸಿದ ಸ್ಥಳ",
    calSuryamanaHelp: "ಸೌರ ಪಂಚಾಂಗ", calAmantaHelp: "ಚಾಂದ್ರಮಾನ — ಅಮಾವಾಸ್ಯೆಗೆ ಮಾಸ ಮುಕ್ತಾಯ",
    calPurnimantaHelp: "ಚಾಂದ್ರಮಾನ — ಹುಣ್ಣಿಮೆಗೆ ಮಾಸ ಮುಕ್ತಾಯ",
  },
  ml: {
    navHome: "ഹോം", navPanchangam: "പഞ്ചാംഗം", langBtn: "ഭാഷകൾ ▼",
    goodMorning: "സുപ്രഭാതം", goodAfternoon: "ശുഭ ഉച്ച",
    goodEvening: "ശുഭ സായാഹ്നം", goodNight: "ശുഭ രാത്രി",
    subHeading: "ഇന്നത്തെ യാജ്ഞിക പഞ്ചാംഗം",
    lblSamvatsaram: "സംവത്സരം:", lblAyanam: "അയനം:", lblRithuvu: "ഋതു:",
    lblMasam: "മാസം:", lblPaksham: "പക്ഷം:", lblThidhi: "തിഥി:", lblNakshatram: "നക്ഷത്രം:",
    btnFullPanchangam: "സമ്പൂർണ്ണ പഞ്ചാംഗം", kalaChakram: "കാല ചക്രം",
    sunrise: "സൂര്യോദയം", sunset: "സൂര്യാസ്തമയം", moonrise: "ചന്ദ്രോദയം", moonset: "ചന്ദ്രാസ്തമയം",
    suryamana: "സൗരമാനം", amanta: "ചാന്ദ്രമാനം (അമാന്ത)", purnimanta: "ചാന്ദ്രമാനം (പൂർണ്ണിമാന്ത)",
    lblMasamSuryamana: "സൗര മാസം", lblMasamAmanta: "അമാന്ത മാസം", lblMasamPurnimanta: "പൂർണ്ണിമാന്ത മാസം",
    modalTimingsKalas: "സമയങ്ങളും കാലങ്ങളും", modalPanchangamDetails: "പഞ്ചാംഗ വിവരങ്ങൾ",
    lblYogam: "യോഗം", lblKaranam: "കരണം",
    muhurtamTitle: "മുഹൂർത്തം പരിശോധിക്കുക", muhurtamSub: "ശുഭ മുഹൂർത്ത അന്വേഷണം",
    muhurtamNakshatra: "നിങ്ങളുടെ നക്ഷത്രം", muhurtamRasi: "നിങ്ങളുടെ രാശി", muhurtamSystem: "പഞ്ചാംഗ രീതി",
    muhurtamChandramana: "ചാന്ദ്രമാനം", muhurtamSouramana: "സൗരമാനം", muhurtamBest: "ഏറ്റവും നല്ലത് (രണ്ടും)",
    muhurtamStartDate: "മുതൽ", muhurtamEndDate: "വരെ", muhurtamCheck: "നല്ല മുഹൂർത്തങ്ങൾ കണ്ടെത്തുക",
    muhurtamChecking: "പരിശോധിക്കുന്നു...", muhurtamNoResults: "ഈ കാലയളവിൽ നല്ല മുഹൂർത്തം കണ്ടെത്തിയില്ല. കാലയളവ് വർദ്ധിപ്പിച്ച് ശ്രമിക്കുക.",
    muhurtamExcluded: "ഒഴിവാക്കിയ സമയങ്ങൾ", muhurtamRahuKalam: "രാഹുകാലം", muhurtamDurmuhurtam: "ദുർമുഹൂർത്തം",
    muhurtamVarjyam: "വർജ്യം", muhurtamSafeWindows: "ശുഭ സമയങ്ങൾ", muhurtamLagna: "ലഗ്നം",
    muhurtamLatitude: "അക്ഷാംശം", muhurtamLongitude: "രേഖാംശം", muhurtamTimezone: "സമയമേഖല (UTC ഓഫ്‌സെറ്റ്, മണി)",
    muhurtamUseLocation: "📍 എന്റെ ലൊക്കേഷൻ ഉപയോഗിക്കുക", muhurtamLocating: "ലൊക്കേഷൻ കണ്ടെത്തുന്നു...",
    muhurtamLocationError: "നിങ്ങളുടെ ലൊക്കേഷൻ ലഭിക്കാനായില്ല. ദയവായി അക്ഷാംശം/രേഖാംശം സ്വയം നൽകുക.",
    muhurtamDisclaimerTitle: "ഈ പരിശോധന എന്തിനെല്ലാം ബാധകമാണ്",
    muhurtamSuitableFor: "✅ ഇവയ്ക്ക് അനുയോജ്യം (പൊതു ശുഭ കാര്യങ്ങൾ)",
    muhurtamNotSuitableFor: "⚠️ ഇവയ്ക്ക് അനുയോജ്യമല്ല (പ്രധാന ജീവിത ചടങ്ങുകൾ)",
    muhurtamDisclaimerNote: "ഈ പരിശോധന താരാ ബലം, ചന്ദ്ര ബലം, തിഥി/വാര നിയമങ്ങൾ, പഞ്ചക രഹിതം എന്നിവ പരിശോധിക്കുന്നു, എന്നാൽ നിർദ്ദിഷ്ട ഭാവങ്ങളിലെ ഗ്രഹങ്ങളുടെ യഥാർത്ഥ സ്ഥാനങ്ങൾ ഇതുവരെ പരിശോധിക്കുന്നില്ല. മുകളിൽ പറഞ്ഞ ജീവിത ചടങ്ങുകൾക്ക് തീയതി ഉറപ്പിക്കുന്നതിന് മുമ്പ് ദയവായി യോഗ്യതയുള്ള ഒരു പുരോഹിതനെയോ ജ്യോതിഷിയെയോ സമീപിക്കുക.",
    muhurtamGotIt: "മനസ്സിലായി",
    muhurtamInlineNote: "⚠️ പൊതു കാര്യങ്ങൾക്ക് മാത്രം (ജോലി, വാഹനം, യാത്ര, സ്വത്ത് മുതലായവ) — വിവാഹം, ഗൃഹപ്രവേശം, ഉപനയനം അല്ലെങ്കിൽ നാമകരണത്തിന് അല്ല. വിശദാംശങ്ങൾക്ക് ⓘ അമർത്തുക.",
    extGraha: "ഗ്രഹ സ്ഥാനങ്ങൾ", extLagna: "ലഗ്നം", extChoghadiya: "ചൗഘടിയ",
    extHora: "ഹോറ", extGowri: "ഗൗരി പഞ്ചാംഗം", extNakshatraInfo: "നക്ഷത്ര വിവരങ്ങൾ",
    extDishaShoola: "ദിശാ ശൂലം (ഈ ദിശയിലേക്ക് യാത്ര ഒഴിവാക്കുക)", extLord: "അധിപൻ", extDeity: "ദേവത",
    extGana: "ഗണം", extNadi: "നാഡി", extRetrograde: "വക്രം", extCombust: "അസ്തമയം",
    extRiseSet: "ഉദയം / അസ്തമയം", extDay: "പകൽ", extNight: "രാത്രി", extSpecialDay: "ഇന്ന്:",
    extEkadashi: "ഏകാദശി", extPournami: "പൗർണ്ണമി", extAmavasya: "അമാവാസി",
    extBhadra: "ഭദ്ര (വിഷ്ടി കരണം) ഉണ്ട്",
    muhurtamCitySearch: "നഗരം / സ്ഥലം തിരയുക",
    locPincode: "പിൻ കോഡ് (ഇന്ത്യ)", locPincodePlaceholder: "6 അക്ക പിൻ കോഡ്",
    locPincodeNotFound: "പിൻ കോഡ് കണ്ടെത്തിയില്ല", locPickMap: "📍 മാപ്പിൽ തിരഞ്ഞെടുക്കുക",
    mapPickerTitle: "മാപ്പിൽ സ്ഥലം തിരഞ്ഞെടുക്കുക", mapPickerHint: "മാപ്പിൽ എവിടെയും ടാപ്പ് ചെയ്യുക",
    mapPickerConfirm: "സ്ഥിരീകരിക്കുക", mapPickerSearchPlaceholder: "നഗരം അല്ലെങ്കിൽ പിൻ കോഡ് തിരയുക",
    mapPickerSearchNoResults: "പൊരുത്തങ്ങളില്ല — മാപ്പിൽ ടാപ്പ് ചെയ്യുക", mapPickerSearching: "തിരയുന്നു…",
    locSearching: "തിരയുന്നു…", locSearchNoResults: "പൊരുത്തങ്ങളൊന്നും കണ്ടെത്തിയില്ല",
    locNear: "സമീപം", locCustom: "നിങ്ങൾ നൽകിയ സ്ഥലം",
    calSuryamanaHelp: "സൗര പഞ്ചാംഗം", calAmantaHelp: "ചാന്ദ്രമാനം — അമാവാസിയിൽ മാസം അവസാനിക്കുന്നു",
    calPurnimantaHelp: "ചാന്ദ്രമാനം — പൗർണ്ണമിയിൽ മാസം അവസാനിക്കുന്നു",
  },
};

export function LanguageProvider({ children }) {
  const [lang, setLang] = useState(() => localStorage.getItem("yagnika_lang") || "en");
  const [dict, setDict] = useState(FALLBACK);
  const [loaded, setLoaded] = useState(false);

  useEffect(() => {
    (async () => {
      try {
        const remote = await fetchTranslations();
        // Merge fallback + remote (remote wins) for every supported language
        const merged = {};
        for (const l of SUPPORTED_LANGS) {
          merged[l] = { ...FALLBACK[l], ...(remote[l] || {}) };
        }
        setDict(merged);
      } catch {
        setDict(FALLBACK);
      } finally {
        setLoaded(true);
      }
    })();
  }, []);

  const setLanguage = useCallback((l) => {
    setLang(l);
    localStorage.setItem("yagnika_lang", l);
  }, []);

  const t = useCallback(
    (key) => (dict[lang] && dict[lang][key]) || (dict.en && dict.en[key]) || key,
    [dict, lang]
  );

  return (
    <LanguageContext.Provider value={{ lang, setLanguage, t, dict, loaded }}>
      {children}
    </LanguageContext.Provider>
  );
}

export const useLanguage = () => useContext(LanguageContext);
